import { useResponsiveValue } from '@superdispatch/ui';
import { hideIntercomLauncher } from './Intercom';
import { getBotpress, loadBotpress } from 'shared/modules/botpress/Botpress';

export function useCustomerSupport() {
  const isMobile = useResponsiveValue(true, false);

  const openBotpress = (message?: string) => {
    void loadBotpress().then(() => {
      void getBotpress().then((botpress) => {
        botpress.open();
        if (message) {
          botpress.sendMessage(message);
        }
      });
    });
  };

  const closeBotpress = () => {
    void getBotpress().then((botpress) => {
      botpress.close();
    });
  };

  const showLauncher = () => {
    if (isMobile) return;
    hideIntercomLauncher();
  };

  const showLauncherMessanger = (message?: string) => {
    openBotpress(message);
  };

  const hideLauncher = () => {
    hideIntercomLauncher();
    closeBotpress();
  };

  return { showLauncher, hideLauncher, showLauncherMessanger };
}
